export default "__VITE_ASSET__8164a12c__"